export enum LcdSubscriptions {
    NEWS = 'NEWS',
    RESEARCH = 'RESEARCH',
}
